import { Platform } from 'react-native';
import { evaluate as evaluateIOS } from './evaluate.ios';
import { evaluate as evaluateAdr } from './evaluate.android';
import * as indexes from './index-def';
const isIOS = Platform.OS === 'ios';
const evaluate = isIOS ? evaluateIOS : evaluateAdr;
let isSlowDevice;
export { evaluate, indexes };
/**
 * 获取设备分级标识
 */
export async function initDeviceLevel() {
    // 获取设备性能分级
    try {
        // 获取设备性能分级
        // @ts-ignore
        const { index } = await evaluate();
        // 小于等于2则认为是低端机
        isSlowDevice = index <= indexes.INDEX_2;
        return index;
    }
    catch (e) {
        isSlowDevice = false;
        return indexes.INDEX_UNKNOWN;
    }
}
/**
 * 是否是非低端机
 */
export function isFastMachine() {
    return !isSlowDevice;
}
